import { NotificationSuccessIcon } from '@tableau/icons/NotificationSuccessIcon';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { isCnameVerified } from '../helpers/CustomDomainHelper';
import { CustomDomainSettingResponse } from '../serverAPI/types/CustomDomainTypes';
import { customDomainHeaderContainer, customDomainSubHeaderStyle, lineIconBaseStyle, progressIconContent, stepIconDiabledStyle, stepIconStyle, subHeaderDisabledStyle, successIconStyle } from '../styles/CustomDomainStyles';
import { UploadSSLCertificateView } from './UploadSSLCertificateView';

export interface UploadSSLContainerProps {
  customDomainSetting: CustomDomainSettingResponse;
  triggerFetchCustomDomain(): void;
}

export class UploadSSLContainerView extends React.PureComponent<UploadSSLContainerProps, {}> {
    private progressStepStyle: React.CSSProperties = undefined;
    private subHeaderStyle: React.CSSProperties = undefined;
    public constructor(props: UploadSSLContainerProps) {
      super(props);
    }

    private renderIcon() {
      if(this.props.customDomainSetting?.tls_certificate_uploaded_date) {
        return <NotificationSuccessIcon size={24} alt='' className={successIconStyle}/>;
      }
      if(isCnameVerified(this.props.customDomainSetting?.status)) {
        return <div className={stepIconStyle} data-tb-test-id={'uploadTls-step-icon'}><div className = {progressIconContent}>3</div></div>;
      }
      return <div className={stepIconDiabledStyle} data-tb-test-id={'uploadTls-disabled-step-icon'}><div className = {progressIconContent}>3</div></div>;
    }

    //Sets styles and icons based on the state of Upload TLS view. 
    private setViewStyles() {
      this.progressStepStyle = lineIconBaseStyle;
      if(isCnameVerified(this.props.customDomainSetting?.status)) {
        this.subHeaderStyle = customDomainSubHeaderStyle;
      } else {
        this.subHeaderStyle = subHeaderDisabledStyle;
      }
    }

    public render() {
      return (
      <>
      <div className={customDomainHeaderContainer}>
        {this.renderIcon()}
        {this.setViewStyles()}
        <strong style={this.subHeaderStyle}>{Messages.CustomDomainSetting_uploadSslDescription() }</strong>
      </div>
      <div style={this.progressStepStyle}>
        {isCnameVerified(this.props.customDomainSetting?.status) ?
          <UploadSSLCertificateView customDomainSetting={this.props.customDomainSetting} triggerFetchCustomDomain={this.props.triggerFetchCustomDomain}/> : null }
      </div>
      </>
      );
    }
}